import {BaseUtils} from "./base.utils";
import {IDocument} from "../../interfaces/document.definition";

export interface IStory extends IDocument{
   oneTime:boolean;
  scenes:Array<IScene>;
}

export interface IScene {
  type:number;
  params:object;
}

export interface ISlide {
  url:string;
  transitionType:number;
}

export interface ITalk {
  leftChar:number;
  rightChar:number;
  speech:string;
  leftCharSpeaks:boolean;
  emotion:number;
  locales:Array<any>;
}

export class StoryUtils extends BaseUtils{
  createScene(type:number):IScene{
    let s:IScene = <IScene>{type: type,
                            params: {
                              delay:0
                            }
                          };
    return s;
  }

  createTalk():ITalk{
    let t:ITalk = <ITalk>{
      leftChar:-1,
      rightChar:-1,
      speech:"",
      leftCharSpeaks:true,
      emotion:0
    };
    return t;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/factory-service-impl/story.utils.ts